import React, { Component } from "react";

export default class SelectedBox extends Component {
  render() {
    return (
      <button className="vendor-type-btn mr-12 mb-12" onClick={this.props.onClick}>
        {this.props.text + " "}
        <span className="pull-right">&times;</span>
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/SelectedBox.js